<template>
  <router-view />
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

#app {
  font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

/* Vuetify overrides for dark theme */
.v-dialog .v-overlay__content {
  background: transparent !important;
  box-shadow: none !important;
}

.v-field--variant-outlined .v-field__outline {
  color: rgba(255, 255, 255, 0.3);
}

.v-field--variant-outlined.v-field--focused .v-field__outline {
  color: rgba(44, 125, 160, 0.8);
}

.v-slider .v-slider-track__fill {
  background: linear-gradient(135deg, #2c7da0 0%, #61a5c2 100%);
}

.v-slider .v-slider-thumb {
  background: linear-gradient(135deg, #2c7da0 0%, #61a5c2 100%);
}

/* Smooth transitions */
* {
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;
}

button,
a {
  transition: all 0.3s ease;
}
</style>
